module.exports = __webpack_public_path__ + "components/MapControl/svg/Basen.svg?510382a3";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Basen.svg
// module id = 1912
// module chunks = 0